module.exports = __webpack_public_path__ + "static/img/female-bg-ar.70c98a66.png";